import React from "react";
import AppLayout from "../../core/layouts/AppLayout";
import "../../styles/listing.scss";
import "../../styles/settings.scss";

import LeftMenu from "./components/menu";
import RequirementReason from "./components/invoice-rejection-reason";
import InvoiceTransactionRejectReason from "./components/invoice-transaction-rejection-reason";

enum TabNames {
    InvoiceRejectedReason = "Invoice Rejected Reason",
    InvoiceTransactionRejectedReason = "Invoice Transaction Rejected Reason",
}

const Home: React.FunctionComponent = () => {
    const [tabName, setTabName] = React.useState<string>(TabNames.InvoiceRejectedReason);
    const handleTabChange = (tabNameValue: string) => {
        setTabName(tabNameValue);
    };

    return (
        <AppLayout>
            <div className="list-head border-bottom py-4 px-3">
                <h2 className="m-0 font-weight-semibold">Invoice Settings</h2>
            </div>
            <div className="row no-gutters ch-100">
                <LeftMenu
                    tabChangeHandler={handleTabChange}
                    tabName={tabName}
                    isAuthRequired={true}
                />
                {tabName === TabNames.InvoiceRejectedReason && <RequirementReason />}
                {tabName === TabNames.InvoiceTransactionRejectedReason && <InvoiceTransactionRejectReason />}

            </div>
        </AppLayout>
    );
};

export default Home;
